import React, { Component } from "react";

import axios from "axios";
import "./Search.css";

import { Results } from "../../components/results/Results";
import { CustomFilter } from "../../components/customfilter/CustomFilter";
import { useLanguage } from "../../contexts/LanguageContext";
import { useTranslation } from "../../hooks/useTranslation";
import apiWithLanguage from "../../util/apiWithLanguage";
import withDataTranslation from "../../util/withDataTranslation";
import SEOHead from "../../components/seo/SEOHead";

import Util from "../../util/util";

class Search extends Component {
  constructor(ttt) {
    super();
    this.state = {
      itemsList: [],
      topStores: [],
      promoted_products: [],
      filter: [],
      filterCheck: [],
      filterSearch: [],
      oneOption: [],
      mainCategory: 0,
      lastSearch: window.location.search,
      lastQuery: "",
      sortValue: "Najsličniji",
      firstRun: true,
      enteredMobile: false,
      dropFilters: true,
      sortMenuOpen: false,
      loadingSearch: false,
    };
  }

  getCategoryPath = () => {
    var languages = ["ba", "en", "fr", "es", "it", "ru", "ar", "de", "pt", "tr", "zh", "hi", "ur"];
    var segments = window.location.pathname.split("/").filter(Boolean);
    if (languages.includes(segments[0])) {
      segments = segments.slice(1);
    }

    return {
      nowPath0: segments[0],
      nowPath: segments[0] == "k" ? segments[1] : "",
      nowPath2: segments[0] == "k" ? (segments[2] || "") : "",
    };
  };

  componentDidUpdate() {
    var categoryPath = this.getCategoryPath();
    if (this.state.lastSearch !== window.location.search && !categoryPath.nowPath) {
      this.setState(
        { filter: [], filterCheck: [], lastSearch: window.location.search },
        () => {
          this.refreshPageSearch();
        }
      );
    }
  }

  componentDidMount() {
    document.title = this.props.pageTitle;
    // Set language for API calls
    if (this.props.currentLanguage) {
      apiWithLanguage.setLanguage(this.props.currentLanguage);
    }
    this.refreshPageSearch();

    if (window.matchMedia("only screen and (max-width: 768px)").matches) {
      this.setState({ enteredMobile: true, dropFilters: true });
    }
  }

  cleanSeoText = (text) => {
    if (!text) {
      return "";
    }

    return decodeURI(String(text))
      .replace(/-/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };

  getSeoInfo = () => {
    var categoryPath = this.getCategoryPath();
    var baseUrl = window.location.origin.replace("://www.", "://");
    var path = window.location.pathname;
    var currentLanguage = this.props.currentLanguage || "ba";

    if (categoryPath.nowPath) {
      var categoryTerm = this.cleanSeoText(
        [categoryPath.nowPath2, categoryPath.nowPath].filter(Boolean).join(" " )
      );
      categoryTerm = Util.firstLettersUppercase(categoryTerm);
      var canonicalPath = "/k/" + categoryPath.nowPath + (categoryPath.nowPath2 ? "/" + categoryPath.nowPath2 : "");
      if (this.props.getPathWithLanguage) {
        canonicalPath = this.props.getPathWithLanguage(canonicalPath, currentLanguage);
      }

      return {
        title: categoryTerm + " - oglasi, cijene i prodaja | OPK.ba",
        description:
          "Pogledajte nove i polovne " +
          categoryTerm.toLowerCase() +
          " oglase na OPK.ba. Uporedite cijene, lokacije i prodavce u Bosni i Hercegovini.",
        canonical: baseUrl + canonicalPath,
        robots: "index, follow",
        listName: categoryTerm
      };
    }

    var params = new URLSearchParams(window ? window.location.search : {});
    var queryTerm = this.cleanSeoText(params.get("q"));
    if (queryTerm) {
      var searchPath = "/pretraga?q=" + encodeURIComponent(queryTerm);
      if (this.props.getPathWithLanguage) {
        searchPath = this.props.getPathWithLanguage("/pretraga", currentLanguage) + "?q=" + encodeURIComponent(queryTerm);
      }

      return {
        title: Util.firstLettersUppercase(queryTerm) + " - oglasi i cijene | OPK.ba",
        description:
          "Rezultati pretrage za " +
          queryTerm +
          " na OPK.ba. Pregledajte aktuelne oglase, cijene, lokacije i prodavce u Bosni i Hercegovini.",
        canonical: baseUrl + searchPath,
        robots: "index, follow",
        listName: queryTerm
      };
    }

    var canonicalPath = this.props.getPathWithLanguage
      ? this.props.getPathWithLanguage("/pretraga", currentLanguage)
      : path;

    return {
      title: "Pretraga oglasa | OPK.ba",
      description: "Pretražite aktuelne oglase za kupovinu i prodaju na OPK.ba.",
      canonical: baseUrl + canonicalPath,
      robots: "noindex, follow",
      listName: "Pretraga oglasa"
    };
  };

  getItemListJsonLd = (seoInfo) => {
    if (!this.state.itemsList || this.state.itemsList.length == 0) {
      return "";
    }

    var currentLanguage = this.props.currentLanguage || "ba";
    var baseUrl = window.location.origin.replace("://www.", "://");
    var items = this.state.itemsList.slice(0, 12).map((product, i) => {
      var productPath = "/p/" + product.link;
      if (this.props.getPathWithLanguage) {
        productPath = this.props.getPathWithLanguage(productPath, currentLanguage);
      }

      var item = {
        "@type": "ListItem",
        "position": i + 1,
        "url": baseUrl + productPath,
        "name": product.name
      };

      if (product.image) {
        item.image = product.image;
      }

      return item;
    });

    return JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": seoInfo.listName + " - OPK.ba",
      "itemListElement": items
    });
  };

  refreshPageSearch = () => {
    var categoryPath = this.getCategoryPath();
    var nowPath = categoryPath.nowPath;
    var nowPathSave = nowPath;
    var nowPath2 = categoryPath.nowPath2;
    var nowPath0 = categoryPath.nowPath0;
    if (nowPath0 == "k") {
      nowPath = nowPath.replace(/-/g, " ");
      nowPath2 = nowPath2.replace(/-/g, " ");
    }

    var mainThis = this;
    if (nowPath) {
      if (this.state.firstRun) {
        var ret = Util.storagePreload(
          [
            "category_" + nowPath + "_" + nowPath2,
            "categoryf_" + nowPath + "_" + nowPath2,
            "categoryf2_" + nowPath + "_" + nowPath2,
          ],
          "json",
          [],
          false
        );
        this.setState({
          itemsList: ret["category_" + nowPath + "_" + nowPath2],
          promoted_products: ret["category_" + nowPath + "_" + nowPath2],
        });

        var savedList = localStorage.getItem(
          "category_" + nowPath + "_" + nowPath2
        );
        if (savedList) {
          savedList = JSON.parse(savedList);
        }
        if (savedList) {
          this.setState({
            lastQuery: nowPath + " " + nowPath2,
            itemsList: savedList,
          });
          document.title =
            Util.firstLettersUppercase(decodeURI(nowPath2 + " " + nowPath)) +
            " na OPK.ba";
        }
      }
      this.setState({ loadingSearch: true });
      var oldFilters = [this.state.filter, this.state.filterCheck];

      apiWithLanguage
        .getCategoryData({
          category: decodeURI(nowPathSave),
          filter: nowPath2,
          customFilter: this.state.filterSearch,
          mainCategory: this.state.mainCategory,
          oldFilters: oldFilters,
          sort_value: this.state.sortValue,
        })
        .then((res) => {
          mainThis.setState({
            firstRun: false,
            loadingSearch: false,
            lastQuery: nowPath + " " + nowPath2,
            itemsList: res["data"]["responseData"]["products"],
            filter: res["data"]["responseData"]["filter"],
            filterCheck: res["data"]["responseData"]["filtercheck"],
            mainCategory: res["data"]["responseData"]["mainCategory"],
            promoted_products: res["data"]["responseData"]["promoted_products"],
          });

          document.title =
            Util.firstLettersUppercase(decodeURI(nowPath2 + " " + nowPath)) +
            " na OPK.ba";

          localStorage.setItem(
            "category_" + nowPath + "_" + nowPath2,
            JSON.stringify(res["data"]["responseData"]["products"])
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      var params = new URLSearchParams(window ? window.location.search : {});
      var queryTerm = this.cleanSeoText(params.get("q"));
      this.setState({ loadingSearch: true });
      apiWithLanguage
        .searchProducts({
          loc: params.get("l"),
          filter: queryTerm,
          customFilter: this.state.filterSearch,
          mainCategory: this.state.mainCategory,
          oldFilters: [this.state.filter, this.state.filterCheck],
          sort_value: this.state.sortValue,
        })
        .then((res) => {
          document.title = queryTerm
            ? Util.firstLettersUppercase(queryTerm) + " - OPK.ba"
            : "Pretraga oglasa - OPK.ba";
          mainThis.setState({
            firstRun: false,
            loadingSearch: false,
            lastQuery: queryTerm,
            itemsList: res["data"]["responseData"]["products"],
            filter: res["data"]["responseData"]["filter"],
            filterCheck: res["data"]["responseData"]["filtercheck"],
            mainCategory: res["data"]["responseData"]["mainCategory"],
            topStores: res["data"]["responseData"]["topstores"],
            lastSearch: window.location.search,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  updateCustomFilter = (val, callback) => {
    if (callback) {
      this.setState(val, callback);
    } else {
      this.setState(val);
    }
  };

  resetFilters = () => {
    this.setState(
      {
        filterSearch: [],
        filter: [],
        filterCheck: [],
        lastQuery: "",
        firstRun: true,
      },
      () => {
        this.refreshPageSearch();
      }
    );
  };

  updateDone = () => {
    var filterQuery = [];
    for (var itemf of this.state.filter) {
      if (itemf["fromto"]) {
        if (itemf["value"] && !itemf["value1"]) {
          filterQuery.push({
            title: itemf["id"],
            option: [{ val: itemf["value"], dir: "min" }],
          });
        } else if (!itemf["value"] && itemf["value1"]) {
          filterQuery.push({
            title: itemf["id"],
            option: [{ val: itemf["value1"], dir: "max" }],
          });
        } else if (itemf["value"] && itemf["value1"]) {
          filterQuery.push({
            title: itemf["id"],
            option: [
              { val: itemf["value"], val1: itemf["value1"], dir: "both" },
            ],
          });
        }
      } else if (itemf["value"]) {
        filterQuery.push({ title: itemf["id"], option: [itemf["value"]] });
      }
    }

    var otherList = [];
    for (itemf of this.state.filterCheck) {
      if (itemf["checked"]) {
        otherList.push(itemf["id"]);
      }
    }

    if (otherList.length > 0) {
      filterQuery.push({ title: "Ostalo", option: otherList });
    }

    this.setState({ filterSearch: filterQuery }, () => {
      this.refreshPageSearch();
    });
  };

  showFilters = () => {
    this.setState({ dropFilters: !this.state.dropFilters });
  };

  sortBy = (sortValue) => {
    this.setState({ sortValue: sortValue }, () => {
      this.refreshPageSearch();
    });
  };

  render() {
    var seoInfo = this.getSeoInfo();
    var itemListJsonLd = this.getItemListJsonLd(seoInfo);

    return (
      <div className="search_page">
        <SEOHead
          title={seoInfo.title}
          description={seoInfo.description}
          canonical={seoInfo.canonical}
          robots={seoInfo.robots}
        />
        {itemListJsonLd && (
          <script type="application/ld+json">{itemListJsonLd}</script>
        )}
        <div className="see_filters_button" onClick={this.showFilters}>
          {this.state.dropFilters
            ? "Prikaži sve filtere"
            : "Sakrij sve filtere"}
        </div>
        <div
          className={
            "page_1of4" +
            (this.state.dropFilters ? " search_page_hide_1of4" : "")
          }
        >
          {this.state.filterSearch.length !== 0 && (
            <div className="filter_list_item">
              <div className="reset_btn" onClick={this.resetFilters}>
                Resetuj
              </div>
            </div>
          )}
          <CustomFilter
            currentList={this.state.filter}
            checkbox={false}
            updateCustomFilter={this.updateCustomFilter}
            callback={this.updateDone}
          />
          <CustomFilter
            currentList={this.state.filterCheck}
            checkbox={true}
            updateCustomFilter={this.updateCustomFilter}
            callback={this.updateDone}
          />
        </div>
        {!this.state.dropFilters && (
          <div className="see_filters_button" onClick={this.showFilters}>
            Sakrij sve filtere
          </div>
        )}
        <div className="page_3of4">
          {!this.state.loadingSearch && (
            <Results
              promotedList={this.state.promoted_products}
              lastSearch={this.state.lastQuery}
              storesList={this.state.topStores}
              productsList={this.state.itemsList}
              sortMenu={this.sortMenu}
              sortMenuOpen={this.state.sortMenuOpen}
              sortValue={this.state.sortValue}
              sortBy={this.sortBy}
              currentLanguage={this.props.currentLanguage}
              getPathWithLanguage={this.props.getPathWithLanguage}
            />
          )}
        </div>
        <div
          className={
            "loader_holder" + (this.state.loadingSearch ? " active" : "")
          }
        >
          <div className="loader_big"></div>
        </div>
      </div>
    );
  }
}

// Wrap with data translation HOC
const SearchWithTranslation = withDataTranslation(Search);

export default SearchWithTranslation;
